
function sendFormToCalltouch(formEl) {

    if (!window.CalltouchDataObject || !getCalltouchParams()) {
        return;
    }
    var subject = formEl.dataset.ctSubject;

    if (!subject || !formEl) return

    var data = Object.fromEntries(new FormData(formEl));

    var ct_data = {
        fio: data.name || '',
        phoneNumber: data.phone || '',
        subject: subject || '',
        requestUrl: location.href,
        sessionId: getSessionId()
    };

    jQuery.ajax({
        url: "https://api.calltouch.ru/calls-service/RestAPI/requests/" + getSiteId() + "/register/",
        dataType: 'json',
        type: 'POST',
        data: ct_data
    });
}
